import useMultpleTable from '../../../hooks/useMultipleTable';
import { Table } from '../../Table';
import { MultiTableComponentProps } from '../types';

const columnLables = {
  share_class_flag: {
    name: 'AIF share class flag'
  },
  share_class_national_code: {
    name: 'Share class national code'
  },
  share_class_identifier_isin: {
    name: 'Share class ISIN code'
  },
  share_class_identifier_sedol: {
    name: '	Share Class SEDOL Code'
  },
  share_class_identifier_cusip: {
    name: 'Share Class CUSIP Code'
  },
  share_class_identifier_ticker: {
    name: 'Share Class Bloomberg Code'
  },
  share_class_identifier_ric: {
    name: 'Share Class Reuters Code'
  },
  share_class_name: {
    name: 'Share Class Name'
  }
};

export function ShareClasses({
  funds,
  currentDataKey,
  onChangeFund,
  schema,
  isStaticTemplate,
  isMultiFunds,
  onAddColumn,
  onDeleteColumn
}: MultiTableComponentProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useMultpleTable({
    data: funds[currentDataKey]?.fund_data?.SHARE_CLASSES,
    onChangeFund,
    schema: schema.SHARE_CLASSES,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.SHARE_CLASSES?.field_names || [],
    isMultiFunds,
    funds,
    onAddColumn,
    onDeleteColumn,
    columnLables,
    tableName: 'SHARE_CLASSES',
    order: 33,
    hasTableOrderNumber: false
  });

  return (
    <Table
      id="reporttables-share-classes-table"
      handleChanges={onChange}
      columns={columns}
      rows={rows}
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
      stickyTopRows={isMultiFunds ? 1 : null}
    />
  );
}
